var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.pageName,{tag:"component",attrs:{"sn":_vm.sn,"deviceType":_vm.deviceType}})}
var staticRenderFns = []

export { render, staticRenderFns }